import * as Yup from 'yup'

import { APPLICANT_DECISION_NOTE_MAX_LENGTH } from '../ApplicantDecisionPanel.constants'
import { getIsApplicantDecisionReasonRequired } from '../ApplicantDecisionPanel.utils'

import { APPLICANT_DECISION_NOTE_FIELD_NAME } from './ApplicantDecisionModal.constants'

export function getApplicantDecisionModalValidationSchema({ action, t }) {
  const note = Yup.string()
    .trim()
    .max(
      APPLICANT_DECISION_NOTE_MAX_LENGTH,
      t('Error.MaxLengthKey', { length: APPLICANT_DECISION_NOTE_MAX_LENGTH })
    )

  return Yup.object({
    [APPLICANT_DECISION_NOTE_FIELD_NAME]: getIsApplicantDecisionReasonRequired(
      action
    )
      ? note.required(true)
      : note,
  })
}

export function getApplicantDecisionModalNote(values) {
  return values[APPLICANT_DECISION_NOTE_FIELD_NAME].trim() || null
}
